import { lbBrand } from '@fuse/colors';
import FuseScrollbars from '@fuse/core/FuseScrollbars';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import Icon from '@material-ui/core/Icon';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Logo from 'app/fuse-layouts/shared-components/Logo';
import NavbarFoldedToggleButton from 'app/fuse-layouts/shared-components/NavbarFoldedToggleButton';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
import UserNavbarHeader from 'app/fuse-layouts/shared-components/UserNavbarHeader';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles({
  content: {
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
  },
});

function NavbarLayout1(props) {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={clsx('flex flex-col overflow-hidden h-full relative', props.className)}>
      <AppBar
        color="primary"
        position="static"
        elevation={0}
        className="flex flex-row items-center flex-shrink h-64 min-h-64 px-12 relative z-10 overflow-hidden"
        style={{
          // The black fill is what separates this block from the white body, so
          // no rule is needed here — hence dropping colorPrimary's 2px red
          // card-header accent rather than recolouring it.
          background: lbBrand.navHeaderBg,
          color: lbBrand.white,
          borderBottom: 'none',
        }}
      >
        {/* The waves PNG is drawn light-on-transparent, so it reads on the black
            band. Nested inside the AppBar it paints over that fill and the
            overflow-hidden clips it to the 64px band. */}
        <img
          src="assets/images/login/login-waves.svg"
          alt=""
          style={{
            position: 'absolute',
            top: 0,
            right: 100,
            height: 200,
            width: 'auto',
            opacity: 0.5,
            pointerEvents: 'none',
            zIndex: 0,
          }}
        />

        <div className="flex flex-1 mx-8 relative">
          <Logo />
        </div>

        <Hidden mdDown>
          <NavbarFoldedToggleButton className="w-40 h-40 p-0" />
        </Hidden>

        <Hidden lgUp>
          <NavbarMobileToggleButton className="w-40 h-40 p-0">
            <Icon>{theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}</Icon>
          </NavbarMobileToggleButton>
        </Hidden>
      </AppBar>

      <FuseScrollbars className={clsx(classes.content, 'relative z-10')} option={{ suppressScrollX: true }}>
        <UserNavbarHeader />

        <Navigation layout="vertical" />
      </FuseScrollbars>
    </div>
  );
}

export default React.memo(NavbarLayout1);
